"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    shoppingCart: {
      actions: {
        addToCart: 'add a kosárhoz',
        buy: 'vásárlás',
        order: 'megrendelés',
        remove: 'eltávolítás'
      },
      cart: {
        total: {
          label: 'összesen',
          helperText: '',
          helperTextPreview: ''
        },
        totalItems: {
          label: 'összes sor',
          helperText: '',
          helperTextPreview: ''
        },
        totalShipping: {
          label: 'összes szállítás',
          helperText: '',
          helperTextPreview: ''
        },
        totalPayment: {
          label: 'összesen fizetendõ',
          helperText: '',
          helperTextPreview: ''
        },
        totalTaxes: {
          label: 'összes adó',
          helperText: '',
          helperTextPreview: ''
        },
        resetCart: 'kosár visszaállítása'
      },
      messages: {
        confirmResetCart: 'Biztosan vissza akarja állítani a kosár tartalmát ?',
        giftClaim: 'kaphat  {quantity} db {productName}-ot ajándékkként.',
        cartManipulations: {
          allRemoved: 'Minden termék el lett távolítva a kosárból.',
          itemAdded: '{number, plural, one {An item} other {Items}} hozzáadta a kosárhoz.',
          itemRemoved: '{number, plural, one {An item} other {Items}} eltávolította a kosarából.',
          quantityChaged: 'a megrendelt mennyiség megváltozott.'
        }
      },
      components: {
        appBartActionCart: 'kosár',
        quantityField: {
          states: {
            quantityRounded: 'a mennyiség kerekítve lett a legközelebbi csomagolási egységhez.'
          }
        },
        cartAsidePreview: {
          cartEmpty: 'Az Ön kosara üres'
        },
        cartAfterAddModal: {
          continueShopping: 'vásárlás folytatása',
          goToCart: 'menj a kosárhoz',
          title: 'a termék hozzá lett adva a kosárhoz',
          pcs: 'darab.'
        }
      }
    }
  }
};
var _default = messages;
exports.default = _default;